module.exports = __webpack_public_path__ + "static/media/pn-pc-gold.15255d90.svg";